import axios from 'axios'

const state = {
  currentProduct: null,
  relatedProducts: [],
  reviews: [],
  reviewStats: null,
  productList: [],
  loading: false,
  error: null,
  filters: {
    category: null,
    priceRange: [0, 10000],
    regions: [],
    packages: []
  },
  pagination: {
    currentPage: 1,
    pageSize: 12,
    total: 0
  },
  specifications: {
    packages: [
      { id: 1, name: '1GB/天', price: 99, description: '适合轻度使用' },
      { id: 2, name: '3GB/天', price: 199, description: '适合普通使用' },
      { id: 3, name: '5GB/天', price: 299, description: '适合重度使用' },
      { id: 4, name: '无限流量', price: 499, description: '无限制使用' }
    ],
    durations: [
      { id: 1, name: '7天', multiplier: 1, description: '短期旅行' },
      { id: 2, name: '15天', multiplier: 1.8, description: '中期旅行' },
      { id: 3, name: '30天', multiplier: 3.5, description: '长期旅行' },
      { id: 4, name: '90天', multiplier: 9, description: '超长期旅行' }
    ],
    regions: [
      { id: 1, name: '中国大陆', code: 'CN' },
      { id: 2, name: '港澳台', code: 'HK' },
      { id: 3, name: '日韩', code: 'JP' },
      { id: 4, name: '东南亚', code: 'SEA' },
      { id: 5, name: '欧洲', code: 'EU' },
      { id: 6, name: '北美', code: 'NA' },
      { id: 7, name: '全球通用', code: 'GLOBAL' }
    ]
  }
}

const mutations = {
  SET_CURRENT_PRODUCT(state, product) {
    state.currentProduct = product
  },
  SET_RELATED_PRODUCTS(state, products) {
    state.relatedProducts = products
  },
  SET_REVIEWS(state, reviews) {
    state.reviews = reviews
  },
  SET_REVIEW_STATS(state, stats) {
    state.reviewStats = stats
  },
  SET_PRODUCT_LIST(state, products) {
    state.productList = products
  },
  SET_LOADING(state, status) {
    state.loading = status
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  SET_FILTERS(state, filters) {
    state.filters = { ...state.filters, ...filters }
  },
  SET_PAGINATION(state, pagination) {
    state.pagination = { ...state.pagination, ...pagination }
  },
  ADD_REVIEW(state, review) {
    state.reviews.unshift(review)
    // 更新评价统计
    if (state.reviewStats) {
      state.reviewStats.totalReviews += 1
      const distribution = state.reviewStats.ratingDistribution.find(
        d => d.rating === review.rating
      )
      if (distribution) {
        distribution.count += 1
        // 重新计算百分比
        state.reviewStats.ratingDistribution.forEach(d => {
          d.percentage = (d.count / state.reviewStats.totalReviews) * 100
        })
      }
    }
  }
}

const actions = {
  updateSelectedProduct({ commit }, product) {
    commit('SET_CURRENT_PRODUCT', product);
  },
  async fetchProductList({ commit, state }, { page = 1, filters = {} } = {}) {
    try {
      commit('SET_LOADING', true)
      // TODO: 替换为实际的API调用
      const response = await new Promise(resolve => {
        setTimeout(() => {
          resolve({
            data: {
              products: [
                {
                  id: 1,
                  name: 'Global eSIM 全球通用流量套餐',
                  description: '支持全球200+国家和地区，即买即用，无需实体卡',
                  images: ['/images/product1.jpg'],
                  price: 99,
                  originalPrice: 199,
                  stock: 999,
                  sales: 1000,
                  rating: 4.8
                }
                // ... 更多产品数据
              ],
              total: 100
            }
          })
        }, 1000)
      })

      commit('SET_PRODUCT_LIST', response.data.products)
      commit('SET_PAGINATION', {
        currentPage: page,
        total: response.data.total
      })
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchProductDetail({ commit }, productId) {
    try {
      commit('SET_LOADING', true)
      // TODO: 替换为实际的API调用
      const response = await new Promise(resolve => {
        setTimeout(() => {
          resolve({
            data: {
              id: productId,
              name: 'Global eSIM 全球通用流量套餐',
              description: '支持全球200+国家和地区，即买即用，无需实体卡',
              images: [
                '/images/product1.jpg',
                '/images/product2.jpg',
                '/images/product3.jpg'
              ],
              price: 99,
              originalPrice: 199,
              stock: 999,
              sales: 1000,
              rating: 4.8,
              features: [
                '无需实体卡，扫码即可激活',
                '支持iOS和Android设备',
                '全球200+国家和地区覆盖',
                '24/7客户支持'
              ],
              parameters: [
                { name: '适用设备', value: '支持 eSIM 的智能手机' },
                { name: '激活方式', value: '在线自助激活' },
                { name: '使用说明', value: '扫码导入 eSIM 配置文件' },
                { name: '客服支持', value: '7*24小时在线客服' }
              ]
            }
          })
        }, 1000)
      })
      commit('SET_CURRENT_PRODUCT', response.data)
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchRelatedProducts({ commit }, productId) {
    try {
      // TODO: 替换为实际的API调用
      const response = await new Promise(resolve => {
        setTimeout(() => {
          resolve({
            data: [
              {
                id: 2,
                name: '日本专用 eSIM 5天无限流量套餐',
                image: '/images/product2.jpg',
                price: 99
              },
              {
                id: 3,
                name: '韩国专用 eSIM 7天无限流量套餐',
                image: '/images/product3.jpg',
                price: 129
              }
              // ... 更多相关产品
            ]
          })
        }, 1000)
      })
      commit('SET_RELATED_PRODUCTS', response.data)
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    }
  },

  async fetchProductReviews({ commit }, { productId, page = 1, filter = {} }) {
    try {
      // TODO: 替换为实际的API调用
      const response = await new Promise(resolve => {
        setTimeout(() => {
          resolve({
            data: {
              reviews: [
                {
                  id: 1,
                  userName: '用户***123',
                  rating: 5,
                  content: '信号很好，速度快，客服响应及时',
                  createTime: '2024-03-15 10:00:00',
                  images: ['/images/review1.jpg', '/images/review2.jpg']
                }
                // ... 更多评价
              ],
              stats: {
                avgRating: 4.8,
                totalReviews: 100,
                ratingDistribution: [
                  { rating: 5, percentage: 85, count: 85 },
                  { rating: 4, percentage: 10, count: 10 },
                  { rating: 3, percentage: 3, count: 3 },
                  { rating: 2, percentage: 1, count: 1 },
                  { rating: 1, percentage: 1, count: 1 }
                ]
              }
            }
          })
        }, 1000)
      })
      commit('SET_REVIEWS', response.data.reviews)
      commit('SET_REVIEW_STATS', response.data.stats)
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    }
  },

  async submitReview({ commit }, { productId, review }) {
    try {
      // TODO: 替换为实际的API调用
      const response = await new Promise(resolve => {
        setTimeout(() => {
          resolve({
            data: {
              id: Date.now(),
              userName: '用户***' + Math.floor(Math.random() * 1000),
              createTime: new Date().toISOString(),
              ...review
            }
          })
        }, 1000)
      })
      commit('ADD_REVIEW', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    }
  }
}

const getters = {
  selectedSpecPrice: (state) => (selectedSpecs) => {
    if (!selectedSpecs || !selectedSpecs.package || !selectedSpecs.duration) {
      return 0
    }

    const packageItem = state.specifications.packages.find(
      p => p.id === selectedSpecs.package
    )
    const durationItem = state.specifications.durations.find(
      d => d.id === selectedSpecs.duration
    )

    if (!packageItem || !durationItem) {
      return 0
    }

    return packageItem.price * durationItem.multiplier
  },

  filteredProducts: (state) => {
    let result = [...state.productList]
    
    if (state.filters.category) {
      result = result.filter(p => p.category === state.filters.category)
    }

    if (state.filters.priceRange) {
      result = result.filter(p => 
        p.price >= state.filters.priceRange[0] && 
        p.price <= state.filters.priceRange[1]
      )
    }

    if (state.filters.regions.length) {
      result = result.filter(p => 
        p.regions.some(r => state.filters.regions.includes(r))
      )
    }

    return result
  },

  isLoading: state => state.loading,
  hasError: state => !!state.error,
  errorMessage: state => state.error
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} 